module.exports = __webpack_public_path__ + "static/media/logo_iot_circle.3bde535d.svg";